import Fuse from 'fuse.js';
import { knowledgeBase } from './config';

class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

// ===============================================
// DANS ActionProvider.js, REMPLACEZ CETTE FONCTION
// ===============================================
handleUserMessage = (message, userRole) => {
  // Nettoyer et normaliser le message de l'utilisateur
  const lowerCaseMessage = message.toLowerCase().trim();

  // --- GESTION DES PHRASES DE POLITESSE (INCHANGÉ) ---
  if (lowerCaseMessage.includes('bonjour') || lowerCaseMessage.includes('salut') || lowerCaseMessage.includes('hello')) {
    const helloResponse = this.createChatBotMessage("Bonjour ! Comment puis-je vous aider aujourd'hui ?");
    this.addMessageToState(helloResponse);
    return;
  }
  if (lowerCaseMessage.includes('merci')) {
    const thanksResponse = this.createChatBotMessage("De rien ! N'hésitez pas si vous avez d'autres questions.");
    this.addMessageToState(thanksResponse);
    return;
  }
  
  const relevantKnowledge = knowledgeBase[userRole] || knowledgeBase.default;

  // --- CORRECTION DE LA RECHERCHE EXACTE ---
  // On compare les versions normalisées (minuscules, sans espaces superflus)
  const exactMatch = relevantKnowledge.find(
    (item) => item.question.toLowerCase().trim() === lowerCaseMessage
  );

  if (exactMatch) {
    const botResponse = this.createChatBotMessage(exactMatch.answer);
    this.addMessageToState(botResponse);
    return; // On a trouvé, on s'arrête
  }
  // --- FIN DE LA CORRECTION ---
  
  // La logique Fuse.js reste la même, elle est appelée si aucune correspondance exacte n'est trouvée
  const fuse = new Fuse(relevantKnowledge, {
    keys: ['question'],
    includeScore: true,
    threshold: 0.6,
  });

  const results = fuse.search(lowerCaseMessage);

  let botResponse;

  if (results.length > 0 && results[0].score < 0.3) {
    const bestResult = results[0].item;
    botResponse = this.createChatBotMessage(bestResult.answer);
  } else if (results.length > 0) {
    const suggestions = results.slice(0, 3).map(res => res.item);
botResponse = this.createChatBotMessage(
  "Je ne suis pas sûr d'avoir compris. Vouliez-vous poser une de ces questions ?",
  {
    widget: 'suggestionOptions',
    // On passe maintenant un objet qui contient les suggestions ET le rôle
    payload: {
      suggestions: suggestions,
      userRole: userRole 
    },
  }
);
  } else {
    botResponse = this.createChatBotMessage("Désolé, je n'ai pas trouvé de réponse. Essayez de reformuler.");
  }

  this.addMessageToState(botResponse);
};

  // Helper pour ajouter un message à l'état
  addMessageToState = (message) => {
    this.setState((prevState) => ({
      ...prevState,
      messages: [...prevState.messages, message],
    }));
  };
}

export default ActionProvider;